export enum mainPersonalSettings {
    showProxyBoardsLeftMenu = "showProxyBoardsLeftMenu",
    showSubprojectsProjectPage = "showSubprojectsProjectPage",
    saveBoardFilters = "saveBoardFilters"
}

//Настройки уведомлений пользователя
export enum notificationSettings {
    editTaskEmail = "editTaskEmail",
    editTaskFront = "editTaskFront",
    commentTaskEmail = "commentTaskEmail",
    commentTaskFront = "commentTaskFront",
    createDeleteTaskEmail = "createDeleteTaskEmail",
    createDeleteTaskFront = "createDeleteTaskFront",
    projectEditInfoEmail = "projectEditInfoEmail",
    projectEditInfoFront = "projectEditInfoFront",
    createDeleteSubprojectEmail = "createDeleteSubprojectEmail",
    createDeleteSubprojectInfoFront = "createDeleteSubprojectInfoFront",
    createDeleteBoardEmail = "createDeleteBoardEmail",
    createDeleteBoardFront = "createDeleteBoardFront",
    editBoardEmail = "editBoardEmail",
    editBoardFront = "editBoardFront" 
}

// Комбинация всех персональных настроек пользователя
export const personalSettings = {
    ...notificationSettings,
    ...mainPersonalSettings,
};
